import { WEB_ROUTES } from '@memorai/routes';

export const ROUTES = {
    HOME: '/',
    LOGIN: '/login',
    NOTES: '/notes',
    NOTE_DETAIL: WEB_ROUTES.NOTE,
    SEARCH: WEB_ROUTES.SEARCH,
    CATEGORIES: WEB_ROUTES.CATEGORIES,
    MORE: WEB_ROUTES.MORE,
    BIN: WEB_ROUTES.BIN,
} as const;
